import { ContentFeedForHealthNewsCardProps } from '@ahc-digital/component-library';
import { Field, LinkField, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export type C21ContentFeedForHealthNewsFields = {
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
  CTA?: LinkField;
};

export type C21ContentFeedForHealthNewsParams = {
  BackgroundColor?: string;
  HeadlineTag?: string;
  ContentAlignment?: string;
  HideImagesOnMobile?: string;
  EnableCarouselOnMobile?: string;
  HideSupportCopyOnCards?: string;
  APISlug?: string;
  NumberOfResults?: string;
  SlideTimingInSeconds?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;

export type ServerSideProps = {
  cards?: ContentFeedForHealthNewsCardProps[];
};

export type C21ContentFeedForHealthNewsProps = RenderingProps<
  C21ContentFeedForHealthNewsFields,
  C21ContentFeedForHealthNewsParams
> &
  ServerSideProps;
